








import { Vue, Component } from "vue-property-decorator";
import Sidebar from "@/modules/customization/components/Sidebar.vue";
import CardCarousel from "@/modules/customization/components/CardCarousel.vue";

import { namespace } from "vuex-class";

const Customization = namespace("customization");

@Component({
  components: {
    sidebar: Sidebar,
    "card-carousel": CardCarousel,
  },
})
export default class CustomizationPage extends Vue {
  @Customization.Action("fetchTheme") fetchTheme;

  mounted() {
    this.fetchTheme();
  }
}
